module["exports"] = [
  "Norge"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/nb_NO/address/default_country.js
// module id = 893
// module chunks = 0